 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER2101PREPAREINVESTIGATION from '@/components/0_chapter2101prepareinvestigation'
 import A_CHAPTER2102FLOWRECORDSOFACCOUNTBOOKS from '@/components/1_chapter2102flowrecordsofaccountbooks'
 import A_CHAPTER2103COERCION from '@/components/2_chapter2103coercion'
 import A_CHAPTER2104FILTERINFORMATION from '@/components/3_chapter2104filterinformation'
 import A_CHAPTER2105SUDDENENLIGHTENMENT from '@/components/4_chapter2105suddenenlightenment'
 import A_CHAPTER2106MISERABLEPERFORMANCE from '@/components/5_chapter2106miserableperformance'
 import A_CHAPTER2107PROBING from '@/components/6_chapter2107probing'
 import A_CHAPTER2108GOODOLDMAN from '@/components/7_chapter2108goodoldman'
 import A_CHAPTER2109GATEOFHEAVENLYMYSTERY from '@/components/8_chapter2109gateofheavenlymystery'
 import A_CHAPTER2110THEMOSTPRECIOUSTREASUREWILLAPPEAR from '@/components/9_chapter2110themostprecioustreasurewillappear'
 import A0_CHAPTER2111IVEGOTACLUE from '@/components/10_chapter2111ivegotaclue'
 import A1_CHAPTER2112THEYWEREALLDISAPPOINTED from '@/components/11_chapter2112theywerealldisappointed'
 import A2_CHAPTER2113SKYEYEREPORT from '@/components/12_chapter2113skyeyereport'
 import A3_CHAPTER2114TRACESOFTHEBLACKTURTLEREGION from '@/components/13_chapter2114tracesoftheblackturtleregion'
 import A4_CHAPTER2115KNOWINGSELFANDKNOWINGTHEENEMY from '@/components/14_chapter2115knowingselfandknowingtheenemy'
 import A5_CHAPTER2116THEBIRTHOFTHEMOSTPRECIOUSTREASURE from '@/components/15_chapter2116thebirthofthemostprecioustreasure'
 import A6_CHAPTER2117CONSIDER from '@/components/16_chapter2117consider'
 import A7_CHAPTER2118LOWERSHEATH from '@/components/17_chapter2118lowersheath'
 import A8_CHAPTER2119MESOSCALE from '@/components/18_chapter2119mesoscale'
 import A9_CHAPTER2120DYINGINAPIT from '@/components/19_chapter2120dyinginapit'
 import A0_CHAPTER2121CONTENTION from '@/components/20_chapter2121contention'
 import A1_CHAPTER2122GREATWAR from '@/components/21_chapter2122greatwar'
 import A2_CHAPTER2123STRIKE from '@/components/22_chapter2123strike'
 import A3_CHAPTER2124THETRUTHOFTHEEVENT from '@/components/23_chapter2124thetruthoftheevent'
 import A4_CHAPTER2125ATTRIBUTIONOFTHEMOSTPRECIOUSTREASURES from '@/components/24_chapter2125attributionofthemostprecioustreasures'
 import A5_CHAPTER2126XUANWUPEARL from '@/components/25_chapter2126xuanwupearl'
 import A6_CHAPTER2127MARSHZONE from '@/components/26_chapter2127marshzone'
 import A7_CHAPTER2128XUANWUZHUWEI from '@/components/27_chapter2128xuanwuzhuwei'
 import A8_CHAPTER2129AVILLAGEINTHEDEPTHSOFAMARSH from '@/components/28_chapter2129avillageinthedepthsofamarsh'
 import A9_CHAPTER2130XUANWUFORBIDDENAREA from '@/components/29_chapter2130xuanwuforbiddenarea'
 import A0_CHAPTER2131MISUNDERSTANDING from '@/components/30_chapter2131misunderstanding'
 import A1_CHAPTER2132ANOLDSTORY from '@/components/31_chapter2132anoldstory'
 import A2_CHAPTER2133INTERNALAFFAIRSOFTHEBLACKTURTLEREGION from '@/components/32_chapter2133internalaffairsoftheblackturtleregion'
 import A3_CHAPTER2134REMINISCENTOFTHEPAST from '@/components/33_chapter2134reminiscentofthepast'
 import A4_CHAPTER2135RETURNOFBLACKTORTOISEPEARL from '@/components/34_chapter2135returnofblacktortoisepearl'
 import A5_CHAPTER2136THEWAYOFCULTIVATION from '@/components/35_chapter2136thewayofcultivation'
 import A6_CHAPTER2137DISCUSSIONONTHEFORBIDDENAREAOFBLACKTURTLE from '@/components/36_chapter2137discussionontheforbiddenareaofblackturtle'
 import A7_CHAPTER2138QITIANYUSWORRY from '@/components/37_chapter2138qitianyusworry'
 import A8_CHAPTER2139XUANWURESTRICTEDSUBMISSION from '@/components/38_chapter2139xuanwurestrictedsubmission'
 import A9_CHAPTER2140SOOTHING from '@/components/39_chapter2140soothing'
 import A0_CHAPTER2141CELEBRATION from '@/components/40_chapter2141celebration'
 import A1_CHAPTER2142QIYUNLONGSREQUEST from '@/components/41_chapter2142qiyunlongsrequest'
 import A2_CHAPTER2143NEWSFROMTHEWHITETIGERRESTRICTEDAREA from '@/components/42_chapter2143newsfromthewhitetigerrestrictedarea'
 import A3_CHAPTER2144LEAVETHEFORBIDDENAREAOFTHEBLACKTURTLE from '@/components/43_chapter2144leavetheforbiddenareaoftheblackturtle'
 import A4_CHAPTER2145ONTHEROAD from '@/components/44_chapter2145ontheroad'
 import A5_CHAPTER2146THESECRETOFFORMATIONS from '@/components/45_chapter2146thesecretofformations'
 import A6_CHAPTER2147PASTCOMMUNICATION from '@/components/46_chapter2147pastcommunication'
 import A7_CHAPTER2148ASTRANGEFEELINGINHISHEART from '@/components/47_chapter2148astrangefeelinginhisheart'
 import A8_CHAPTER2149PSEUDOAZURITE from '@/components/48_chapter2149pseudoazurite'
 import A9_CHAPTER2150QIYUNHUSTHOUGHTS from '@/components/49_chapter2150qiyunhusthoughts'
 import A0_CHAPTER2151LAUNCHINVESTIGATION from '@/components/50_chapter2151launchinvestigation'
 import A1_CHAPTER2152SOMEFEATURES from '@/components/51_chapter2152somefeatures'
 import A2_CHAPTER2153COMEUPWITHASOLUTION from '@/components/52_chapter2153comeupwithasolution'
 import A3_CHAPTER2154THETRUTHOFTHEMATTER from '@/components/53_chapter2154thetruthofthematter'
 import A4_CHAPTER2155DEPARTURE from '@/components/54_chapter2155departure'
 import A5_CHAPTER2156SNAKESWALLOWINGELEPHANTWITHINSUFFICIENTGREED from '@/components/55_chapter2156snakeswallowingelephantwithinsufficientgreed'
 import A6_CHAPTER2157DIRECTACTION from '@/components/56_chapter2157directaction'
 import A7_CHAPTER2158TIANHAICITY from '@/components/57_chapter2158tianhaicity'
 import A8_CHAPTER2159CULTIVATION from '@/components/58_chapter2159cultivation'
 import A9_CHAPTER2160EXPANDINGTHEMERIDIANS from '@/components/59_chapter2160expandingthemeridians'
 import A0_CHAPTER2161THESTATUSQUOOFCHILDREN from '@/components/60_chapter2161thestatusquoofchildren'
 import A1_CHAPTER2162SKYSEAAUCTION from '@/components/61_chapter2162skyseaauction'
 import A2_CHAPTER2163ATTENDAUCTION from '@/components/62_chapter2163attendauction'
 import A3_CHAPTER2164RULESOFAUCTION from '@/components/63_chapter2164rulesofauction'
 import A4_CHAPTER2165GUYUECHENG from '@/components/64_chapter2165guyuecheng'
 import A5_CHAPTER2166AUCTIONPARTI from '@/components/65_chapter2166auctionparti'
 import A6_CHAPTER2167AUCTIONPARTII from '@/components/66_chapter2167auctionpartii'
 import A7_CHAPTER2168AUCTIONPARTIII from '@/components/67_chapter2168auctionpartiii'
 import A8_CHAPTER2169THEBROKENSWORD from '@/components/68_chapter2169thebrokensword'
 import A9_CHAPTER2170DEFENSIVESKIRT from '@/components/69_chapter2170defensiveskirt'
 import A0_CHAPTER2171ENDOFAUCTION from '@/components/70_chapter2171endofauction'
 import A1_CHAPTER2172ROBBING from '@/components/71_chapter2172robbing'
 import A2_CHAPTER2173SMALLTRICKS from '@/components/72_chapter2173smalltricks'
 import A3_CHAPTER2174SNAKEFAMILY from '@/components/73_chapter2174snakefamily'
 import A4_CHAPTER2175UNREPENTANT from '@/components/74_chapter2175unrepentant'
 import A5_CHAPTER2176DECISIVEEXTERMINATION from '@/components/75_chapter2176decisiveextermination'
 import A6_CHAPTER2177QITIANYUSWORRY from '@/components/76_chapter2177qitianyusworry'
 import A7_CHAPTER2178CHASTEHEART from '@/components/77_chapter2178chasteheart'
 import A8_CHAPTER2179HOMESICKNESS from '@/components/78_chapter2179homesickness'
 import A9_CHAPTER2180MESSAGEFROMTHESKYEYE from '@/components/79_chapter2180messagefromtheskyeye'
 import A0_CHAPTER2181HOWLINGSKYCITY from '@/components/80_chapter2181howlingskycity'
 import A1_CHAPTER2182OWNERSTRANSACTIONS from '@/components/81_chapter2182ownerstransactions'
 import A2_CHAPTER2183FISHMARKET from '@/components/82_chapter2183fishmarket'
 import A3_CHAPTER2184BLACKMARKET from '@/components/83_chapter2184blackmarket'
 import A4_CHAPTER2185MOTHEROFWHITEJADE from '@/components/84_chapter2185motherofwhitejade'
 import A5_CHAPTER2186DEAL from '@/components/85_chapter2186deal'
 import A6_CHAPTER2187THIEF from '@/components/86_chapter2187thief'
 import A7_CHAPTER2188KIDS from '@/components/87_chapter2188kids'
 import A8_CHAPTER2189HEAVENOFDEATH from '@/components/88_chapter2189heavenofdeath'
 import A9_CHAPTER2190ROTTENWOOD from '@/components/89_chapter2190rottenwood'
 import A0_CHAPTER2191HARVEST from '@/components/90_chapter2191harvest'
 import A1_CHAPTER2192HEAVENLYTHUNDERPEARL from '@/components/91_chapter2192heavenlythunderpearl'
 import A2_CHAPTER2193CHEAP from '@/components/92_chapter2193cheap'
 import A3_CHAPTER2194THEGOODINTENTIONSOFTHEVENDOR from '@/components/93_chapter2194thegoodintentionsofthevendor'
 import A4_CHAPTER2195CRIMINALGROUPS from '@/components/94_chapter2195criminalgroups'
 import A5_CHAPTER2196DREAMLAND from '@/components/95_chapter2196dreamland'
 import A6_CHAPTER2197MASKMAN from '@/components/96_chapter2197maskman'
 import A7_CHAPTER2198AWISEMANKNOWSHISPLACE from '@/components/97_chapter2198awisemanknowshisplace'
 import A8_CHAPTER2199OUYANGCHUN from '@/components/98_chapter2199ouyangchun'
 import A9_CHAPTER2200THEONEWHOSUCCEEDSDIESWHILETHEONEWHODISOBEYSDIES from '@/components/99_chapter2200theonewhosucceedsdieswhiletheonewhodisobeysdies'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter2101prepareinvestigation",
 			"name" : "0_chapter2101prepareinvestigation",
 			"component" : A_CHAPTER2101PREPAREINVESTIGATION
 		},
 		{
 			"path" : "/1_chapter2102flowrecordsofaccountbooks",
 			"name" : "1_chapter2102flowrecordsofaccountbooks",
 			"component" : A_CHAPTER2102FLOWRECORDSOFACCOUNTBOOKS
 		},
 		{
 			"path" : "/2_chapter2103coercion",
 			"name" : "2_chapter2103coercion",
 			"component" : A_CHAPTER2103COERCION
 		},
 		{
 			"path" : "/3_chapter2104filterinformation",
 			"name" : "3_chapter2104filterinformation",
 			"component" : A_CHAPTER2104FILTERINFORMATION
 		},
 		{
 			"path" : "/4_chapter2105suddenenlightenment",
 			"name" : "4_chapter2105suddenenlightenment",
 			"component" : A_CHAPTER2105SUDDENENLIGHTENMENT
 		},
 		{
 			"path" : "/5_chapter2106miserableperformance",
 			"name" : "5_chapter2106miserableperformance",
 			"component" : A_CHAPTER2106MISERABLEPERFORMANCE
 		},
 		{
 			"path" : "/6_chapter2107probing",
 			"name" : "6_chapter2107probing",
 			"component" : A_CHAPTER2107PROBING
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js